import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";

class urlForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <TextInput
                            name="url"
                            value={this.props.values.url}
                            label="url"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("url")}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <Select
                            storeType="remote"
                            component="ComponentConfig"
                            objectValue={false}
                            valueKey="name"
                            labelKey="name"
                            name="component_type"
                            value={this.props.values.component_type}
                            label="Komponens"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("component_type")}
                        />
                    </div>
                    <div className="col-md-6">
                        <TextInput
                            name="component_id"
                            value={this.props.values.component_id}
                            label="Id"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("component_id")}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(urlForm);
